import { apiGet, apiPut } from './api';
import type {
  LearningProgressResponse,
  PaginatedLearningVocabularyResponse,
  LearningVocabularyQueryParams,
} from '../types/learning.types';

export const learningProgressService = {
  /**
   * Get learning vocabularies with summary and optional status filter.
   */
  async getLearningVocabularies(
    params?: LearningVocabularyQueryParams,
  ): Promise<PaginatedLearningVocabularyResponse> {
    return apiGet<PaginatedLearningVocabularyResponse>(
      '/learning/vocabulary',
      params as Record<string, unknown>,
    );
  },

  /**
   * Get learning progress for a specific vocabulary item.
   */
  async getProgressByVocabId(vocabularyId: string): Promise<LearningProgressResponse> {
    return apiGet<LearningProgressResponse>(`/learning-progress/${vocabularyId}`);
  },

  /**
   * Update learning progress for a vocabulary item (upsert).
   */
  async updateProgress(
    vocabularyId: string,
    isLearned: boolean,
  ): Promise<LearningProgressResponse> {
    return apiPut<LearningProgressResponse, { isLearned: boolean }>(
      `/learning-progress/${vocabularyId}`,
      { isLearned },
    );
  },
};
